import React from "react";
import { t } from "i18next";

import { AddressBlockProps } from "@models/services/organisation";
import { applyLocalization } from "@services/common.service";

const AddressBlock: React.FC<AddressBlockProps> = ({ data }) => {
  return (
    <div className="fg-loc-custom-block" data-testid="addressBlock-test">
      <h5>{t("howToFindOrganization")}</h5>
      <div className="fg-find-org gap-3">
        <div className="fg-find-address">
          <p>{applyLocalization(data?.address)}</p>
        </div>
        <span className="fg-find-contact">
          {data?.contactEmail} <br />
          {data?.contactPhone}
        </span>
        <span className="fg-find-info">
          {data?.contactPhone && String(data?.contactPhone) !== "" && (
            <a
              href={`tel:${data?.contactPhone}`}
              className="btn fg-icon-btn"
              data-testid="phone-icon"
            >
              <i className="fa-solid fa-phone"></i>
            </a>
          )}
          {data?.contactEmail && data?.contactEmail !== "" && (
            <a
              href={`mailto:${data?.contactEmail}`}
              className="btn fg-icon-btn"
              data-testid="email-icon"
            >
              <i className="fa-solid fa-envelope"></i>
            </a>
          )}
        </span>
      </div>
    </div>
  );
};

export default AddressBlock;
